module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/performance/pages/home/asset/broadcast_icon.gif";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/performance/pages/home/asset/broadcast_icon.gif
// module id = 1300
// module chunks = 418